"use client";

import React, { useState, useEffect } from "react";
import { toggle } from "./toggle";

type Props = JSX.IntrinsicElements["button"];

export const ToggleButton = ({ children, onClick, ...props }: Props) => {
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    setIsDisabled(false);
  }, []);

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={(e) => {
        toggle(e.currentTarget);
        onClick?.(e);
      }}
      {...props}
    >
      {children}
    </button>
  );
};
